/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
const a="20220627",b="b9a439db8314444a64e506afd8c7bd048e9f7c61";export{a as buildDate,b as commitHash};
